import ContinueButton from './ContinueButton'
import styles from './BackSaveContinueButton.module.css'
function BackSaveContinueButton({
    continueButtonVisibility,
    handleSave,
    handleSaveAndNavigate,
    navigate, // needed for back button
}) {
  return (
      <div className={styles.navButtonRow}>
          <button className={styles.CBTbuttons} id={styles.CBTBack} onClick={() => navigate(-1)}>
              Back
          </button>
          <button className={styles.CBTbuttons} id={styles.CBTSave} onClick={handleSave} disabled={!continueButtonVisibility}>
              Save
          </button>
          <ContinueButton
              continueButtonVisibility={continueButtonVisibility}
              handleSaveAndNavigate={handleSaveAndNavigate}
              styles={styles}
          />
      </div>                
  );
}

export default BackSaveContinueButton;